import React from "react";

const money = n => new Intl.NumberFormat("tr-TR", { style: "currency", currency: "TRY", minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n || 0);
const fmt = d => d ? new Date(d).toLocaleDateString("tr-TR", { day: "2-digit", month: "2-digit", year: "numeric" }) : "—";

const numberToWordsTR = (amount) => {
  const ones = ["", "Bir", "İki", "Üç", "Dört", "Beş", "Altı", "Yedi", "Sekiz", "Dokuz"];
  const tens = ["", "On", "Yirmi", "Otuz", "Kırk", "Elli", "Altmış", "Yetmiş", "Seksen", "Doksan"];
  const thousands = ["", "Bin", "Milyon", "Milyar"];
  let parts = Number(amount).toFixed(2).split(".");
  let tl = parseInt(parts[0], 10);
  let kurus = parseInt(parts[1], 10);
  if (tl === 0 && kurus === 0) return "Sıfır Türk Lirası";

  function convertGroup(n) {
    let str = "";
    let h = Math.floor(n / 100);
    let t = Math.floor((n % 100) / 10);
    let o = n % 10;
    if (h > 0) str += (h === 1 ? "Yüz " : ones[h] + " Yüz ");
    if (t > 0) str += tens[t] + " ";
    if (o > 0) str += ones[o] + " ";
    return str;
  }

  let word = "", i = 0;
  while (tl > 0) {
    let group = tl % 1000;
    if (group > 0) {
      let gStr = convertGroup(group);
      if (i === 1 && group === 1) gStr = ""; 
      word = gStr + thousands[i] + " " + word;
    }
    tl = Math.floor(tl / 1000); i++;
  }
  let result = word.trim() ? word.trim() + " Türk Lirası" : "";
  if (kurus > 0) result += (result ? " " : "") + convertGroup(kurus).trim() + " Kuruş";
  return result || "Sıfır Türk Lirası";
};

export default function IncomeReceipt({ printData, siteSettings, owners }) {
  if (!printData) return null;

  const owner = (owners || []).find(o => o.accounting_code === printData.owner_code) || {};
  const payerName = owner.payer_name || owner.owner_name || printData.adi_soyadi || "...................................................";
  const daireKod = owner.villa_no ? `${owner.villa_no} / ${owner.accounting_code}` : (printData.owner_code || "........................");

  const rawSiteName = (siteSettings?.site_name || siteSettings?.siteName || "BAŞKENT SİTESİ").trim();
  const headerTitle = rawSiteName.toLocaleUpperCase("tr-TR").endsWith("YÖNETİMİ") 
    ? rawSiteName.toLocaleUpperCase("tr-TR") 
    : `${rawSiteName.toLocaleUpperCase("tr-TR")} YÖNETİMİ`;

  const managerName = siteSettings?.manager1 || ".......................................";

  const singleReceiptContent = (
    <div style={{ width: "19cm", height: "12cm", border: "1.5px solid #000", padding: "12px 25px", background: "white", color: "black", fontFamily: "'Times New Roman', Times, serif", boxSizing: "border-box", position: "relative", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
      
      <div>
        {/* Sağ Üst Logo */}
        <div style={{ position: "absolute", top: "10px", right: "20px", width: "40px", height: "40px", borderRadius: "50%", overflow: "hidden", border: "1px solid #ccc" }}>
          <img src="/logo.jpg" alt="Logo" style={{ width: "100%", height: "100%", objectFit: "cover" }} onError={(e) => { e.target.style.display = 'none'; }} />
        </div>

        <h3 style={{ textAlign: "center", margin: "0 0 2px 0", fontSize: "13px", letterSpacing: "1px", color: "#333" }}>
          {headerTitle}
        </h3>
        
        <h2 style={{ textAlign: "center", margin: "0 0 8px 0", fontSize: "18px", textDecoration: "underline", fontWeight: "900" }}>
          TAHSİLAT MAKBUZU
        </h2>

        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "6px", fontSize: "12px" }}>
          <div><strong>Makbuz No:</strong> {printData.id || Math.floor(Math.random() * 90000) + 10000}</div>
          <div><strong>Tarih:</strong> {fmt(printData.date)}</div>
        </div>

        <table style={{ width: "100%", fontSize: "12.5px", borderCollapse: "collapse" }}>
          <tbody>
            <tr>
              <td style={{ padding: "3px 0", width: "25%" }}><strong>Ödeyen:</strong></td>
              <td style={{ padding: "3px 0", borderBottom: "1px dotted #ccc" }}>{payerName}</td>
            </tr>
            <tr>
              <td style={{ padding: "3px 0" }}><strong>Daire No/ Hes.Kodu:</strong></td>
              <td style={{ padding: "3px 0", borderBottom: "1px dotted #ccc" }}>{daireKod}</td>
            </tr>
            <tr>
              <td style={{ padding: "3px 0" }}><strong>Ödenen Dönem:</strong></td>
              <td style={{ padding: "3px 0", borderBottom: "1px dotted #ccc" }}>{printData.description}</td>
            </tr>
            <tr>
              <td style={{ padding: "3px 0" }}><strong>Ödeme Şekli:</strong></td>
              <td style={{ padding: "3px 0", borderBottom: "1px dotted #ccc" }}>{printData.payment_method}</td>
            </tr>
          </tbody>
        </table>

        <div style={{ marginTop: "6px", border: "1.5px solid #000", padding: "5px 12px", display: "flex", alignItems: "center", gap: "15px", background: "#fdfdfd" }}>
          <div style={{ width: "90px", fontSize: "13px" }}><strong>Tutar:</strong></div>
          <div style={{ fontSize: "18px", fontWeight: "900", letterSpacing: "1px" }}>{money(printData.amount)}</div>
        </div>
        
        <div style={{ marginTop: "3px", fontStyle: "italic", fontSize: "11px" }}>
          (Yazıyla: <strong style={{ textTransform: "capitalize" }}>{numberToWordsTR(printData.amount)}</strong>)
        </div>

        <div style={{ marginTop: "4px", fontSize: "11.5px", lineHeight: "1.2" }}>
          <strong>Açıklama:</strong> {printData.description} olarak tahsil edilmiştir. İşbu makbuz, yukarıda belirtilen tutarın tahsil edildiğini gösterir.
        </div>
      </div>

      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "2px", textAlign: "center", fontSize: "11px" }}>
        <div style={{ width: "200px" }}>
          <strong>Ödeyen</strong><br/>
          <span style={{ display: "inline-block", marginTop: "2px", fontWeight: "bold" }}>{payerName}</span><br/>
          (İmza)
        </div>
        <div style={{ width: "200px" }}>
          <strong>Tahsil Eden (Yönetim)</strong><br/>
          <span style={{ display: "inline-block", marginTop: "2px", fontWeight: "bold" }}>{managerName}</span><br/>
          (İmza)
        </div>
      </div>

    </div>
  );

  return (
    <div style={{ width: "19cm", height: "26.5cm", paddingTop: "0.5cm", display: "flex", flexDirection: "column", justifyContent: "space-between", boxSizing: "border-box" }}>
      {singleReceiptContent}
      <div style={{ borderTop: "1px dashed #666", width: "100%", margin: "1mm 0" }} />
      {singleReceiptContent}
    </div>
  );
}